export const visitEventFlowStep = function* (ctx, visitorStep) {
  var _atom$handleCollectDe;
  if (visitorStep.type !== 'eventFlowStep') return;
  const step = visitorStep.value;
  const atom = ctx.flowAtoms[step.type];
  if (!atom) return;
  if (step.params) {
    for (const paramName of atom.allowInteropParams) {
      yield {
        type: 'interopable',
        place: ['params', paramName],
        description: `步骤参数${paramName}`,
        accessType: 'read'
      };
    }
  }
  yield* (atom === null || atom === void 0 || (_atom$handleCollectDe = atom.handleCollectDeps) === null || _atom$handleCollectDe === void 0 ? void 0 : _atom$handleCollectDe.call(atom, ctx, visitorStep)) || [];
};
//# sourceMappingURL=visitEventFlowStep.js.map
